// NEXARA Livestock Logo — geometric "N" with an ascending performance accent.
// Left vertical + diagonal forms the "N", right vertical ends in an ochre upward arrow.
// Palette: Deep Forest Green primary, Ochre accent.

export function LogoMark({ size = 28, primary = "#1A3626", accent = "#D99533", bg }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="NEXARA Livestock logo"
        >
            {bg ? <rect x="0" y="0" width="64" height="64" rx="14" fill={bg} /> : null}
            {/* Left vertical of N */}
            <path d="M14 14 V52" stroke={primary} strokeWidth="6" strokeLinecap="round" />
            {/* Diagonal of N */}
            <path d="M14 14 L50 52" stroke={primary} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            {/* Right vertical of N — shorter, ends below the arrow */}
            <path d="M50 24 V52" stroke={primary} strokeWidth="6" strokeLinecap="round" />
            {/* Ascending ochre arrowhead replacing the top of the right stem */}
            <path d="M50 10 L41 22 L59 22 Z" fill={accent} />
            {/* Subtle accent dot on the left (the rumen / livestock mark) */}
            <circle cx="14" cy="14" r="3.5" fill={accent} />
        </svg>
    );
}

export function Logo({ size = 28, showWordmark = true, wordmarkClass = "", primary = "#1A3626", accent = "#D99533", bg, subtitle, subtitleClass = "" }) {
    return (
        <div className="flex items-center gap-2.5">
            <LogoMark size={size} primary={primary} accent={accent} bg={bg} />
            {showWordmark && (
                <div className="leading-none">
                    <div className={`font-display font-semibold tracking-tight ${wordmarkClass}`}>
                        NEXARA <span className="font-normal opacity-80">Livestock</span>
                    </div>
                    {subtitle ? (
                        <div className={`mt-1 text-[10px] tracking-[0.18em] uppercase ${subtitleClass}`}>{subtitle}</div>
                    ) : null}
                </div>
            )}
        </div>
    );
}
